import styled from 'styled-components';
import { BodyLarge400, TitleLarge500 } from '@nebula/global-styles';
import Button from '@nebula/button';

export const Container = styled.div<{ $isWebview?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ $isWebview }) =>
    $isWebview &&
    `
    min-height: 100vh;
    padding-bottom: 0;
  `}
`;

export const Header = styled.div`
  margin-bottom: 16px;
`;

export const StyledTitle = styled(TitleLarge500)`
  margin-top: 0;
  margin-bottom: 8px;
`;

export const CheckboxGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
`;

export const CheckboxItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;

  input {
    outline: none;
    border-radius: 2px;
  }

  > div > label > div {
    margin-top: 1px;
  }
`;

export const SubInputWrapper = styled.div<{ $isSelect?: boolean; $hasError?: boolean }>`
  margin-top: ${({ $isSelect }) => ($isSelect ? '9px' : '4px')};

  ${({ $hasError }) =>
    $hasError &&
    `
    > div > div {
      border: 1px solid #FA1320;
      background-color: #FFF6F3;
      &: hover {
        border: 1px solid #FA1320;
      }
    }
  `}

  p {
    font-family: 'Roboto', Arial, sans-serif;
    font-size: 16px;
    font-weight: 400;
    margin-top: 3px;
    line-height: 24px;
    color: ${({ theme }) => theme.color.ui.grey[90]};
  }

  input {
    outline: none;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    font-family: 'Roboto', Arial, sans-serif;
  }

  select {
    font-family: 'Roboto', Arial, sans-serif;
  }
`;

export const InputHintText = styled.p`
  font-family: 'Roboto', Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.color.ui.grey[90]};
  margin: 0 0 4px;
`;

export const CharacterCount = styled.p<{ $isError: boolean }>`
  font-family: 'Roboto', Arial, sans-serif;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 20px;
  text-align: right;
  margin: 2px 0 0;
  color: ${({ $isError, theme }) =>
    $isError ? theme.color?.messaging?.red?.[70] || '#FA1320' : theme.color.ui.grey[70]};
`;

export const ValidationError = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-family: 'Roboto', Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.color.messaging.red[70]};

  svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.color.messaging.red[60]} !important;
  }
`;

export const ButtonGroup = styled.div<{ $isWebview?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${({ $isWebview }) =>
    $isWebview &&
    `
    margin-top: auto;
    position: sticky;
    bottom: 0;
    background-color: #ffffff;
    border-top: 1px solid #e2e4e6;
    margin-left: -16px;
    margin-right: -16px;
    padding: 16px;
  `}

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    flex-direction: row;
    gap: 16px;
    position: static;
    margin-left: 0;
    margin-right: 0;
    border-top: none;
    padding: 0;
    background-color: transparent;
  }
`;

export const ContinueButton = styled(Button)`
  font-family: 'Roboto', Arial, sans-serif;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    order: 2;
  }
  font-weight: 500;
  font-size: 14px;
`;

export const BackButton = styled(Button)`
  font-family: 'Roboto', Arial, sans-serif;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    order: 1;
  }
  font-size: 14px;
`;

export const StyledBodyLarge400 = styled(BodyLarge400)`
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const AlertWrapper = styled.div`
  margin-bottom: 24px;
  > div > div {
    line-height: 24px;
   }
  > div > div > div > p {
    font-size: 16px;
    line-height: 24px;
  }
`;
